module.exports = __webpack_public_path__ + "img/flag.e9ace8f.png";